/**
 * 图片Agent页面常量定义
 */

// 任务类型枚举
export const TaskType = {
    // 一键出图类型
    // CUT_TOOL: 31,           // 抠图
    // EXPAND_TOOL: 32,        // 扩图
    // Agent类型
    AGENT_IMAGE_GENERATE: 33, // AGENT图片生成
    AGENT_CUT_TOOL: 34, // AGENT抠图
    AGENT_EXPAND_TOOL: 35 // AGENT扩图
};

// 任务状态枚举（和接口返回保持一致）
export const TaskStatus = {
    GENERATING: 1, // 生成中
    SUCCESS: 2, // 成功
    FAILED: 3, // 失败
    CANCELED: 5 // 取消
};

// 默认 Tiptap 编辑器内容
export const defaultTiptapContent = {
    type: 'doc',
    content: [
        {
            type: 'paragraph',
            content: []
        }
    ]
};

// 默认参数配置（输入区域使用）
export const defaultInputParams = {
    prompt: '',
    refImageList: [],
    landPageUrl: '',
    currentMode: 'agentMode',
    width: 2848,
    height: 1600,
    ratio: '16:9',
    resolution: '2k',
    targetCount: 4,
    tiptapContent: defaultTiptapContent
};

// 尺寸比例选项
export const ratioOptions = [
    {
        label: '16:9',
        value: '16:9',
        icon: 'https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/16_9@2x.png'
    },
    {
        label: '9:16',
        value: '9:16',
        icon: 'https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/9_16@2x.png'
    },
    {
        label: '1:1',
        value: '1:1',
        icon: 'https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/1_1@2x.png'
    },
    {
        label: '4:3',
        value: '4:3',
        icon: 'https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/4_3@2x.png'
    },
    {
        label: '3:4',
        value: '3:4',
        icon: 'https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/agent/3_4@2x.png'
    }
];

// 分辨率选项
export const resolutionOptions = [
    {label: '高清2K', value: '2k'},
    {label: '超清4K', value: '4k'}
];

// 生成数量选项
export const generateCountOptions = [
    {label: '1张', value: 1},
    {label: '2张', value: 2},
    {label: '3张', value: 3},
    {label: '4张', value: 4},
    {label: '5张', value: 5},
    {label: '6张', value: 6}
];

// 占位符文案
export const placeholderText = {
    noReference: '一只穿着宇航服的猫，赛博朋克风格，8k分辨率...',
    hasReference: '帮我把这张图的兔子P成老虎'
};

// 提交限制
export const MIN_SUBMIT_INTERVAL = 1000; // 最小提交间隔（毫秒）
export const MAX_PENDING_TASKS = 3; // 最大进行中任务数

// 文本输入限制
export const MAX_TEXT_LENGTH = 1000; // 最大文本长度
export const MAX_TEXT_ROWS = 5; // 最大行数
export const countOptions = [1, 2, 3, 4, 5, 6, 7, 8];

// 图片格式配置
export const imageFormatConfig = {
    '2k': {
       '1:1': {
            width: 2048,
            height: 2048
        },
        '3:4': {
            width: 1728,
            height: 2304
        },
        '4:3': {
            width: 2304,
            height: 1728
        },
        '9:16': {
            width: 1600,
            height: 2848
        },
        '16:9': {
            width: 2848,
            height: 1600
        }
    },
    '4k': {
       '1:1': {
            width: 4096,
            height: 4096
        },
        '3:4': {
            width: 3520,
            height: 4704
        },
        '4:3': {
            width: 4704,
            height: 3520
        },
        '9:16': {
            width: 3040,
            height: 5504
        },
        '16:9': {
            width: 5504,
            height: 3040
        }
    }
};

// 图片格式配置（用于一键出图、扩图、抠图组件）
export const imageFormatConfig2 = {
    '1:1': {
        width: 206,
        height: 206,
        column: 4,
        gap: 2
    },
    '3:4': {
        width: 206,
        height: 275,
        column: 4,
        gap: 2
    },
    '4:3': {
        width: 206,
        height: 154.5,
        column: 4,
        gap: 2
    },
    '9:16': {
        width: 206,
        height: 366.23,
        column: 4,
        gap: 2
    },
    '16:9': {
        width: 206,
        height: 115.87,
        column: 4,
        gap: 2
    }
};
